import React from 'react';
import { AlertTriangleIcon, PhoneIcon } from 'lucide-react';
export function SafetyFooter() {
  return <section className="py-12 bg-safetyBg" data-id="element-242">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-243">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-244">
          {/* Emergency Warning Box */}
          <div className="bg-primary rounded-[10px] p-8 text-white shadow-lg flex flex-col justify-center" data-id="element-245">
            <div className="flex items-center gap-4 mb-4" data-id="element-246">
              <AlertTriangleIcon className="w-10 h-10 shrink-0" data-id="element-247" />
              <h3 className="text-2xl font-bold" data-id="element-248">911 Emergency Warning</h3>
            </div>
            <p className="text-white/90 text-lg leading-relaxed" data-id="element-249">
              If you are in immediate danger, call 911 first. We are not a
              substitute for emergency services.
            </p>
          </div>

          {/* Dispatch Center Box */}
          <div className="bg-secondary rounded-[10px] p-8 text-white shadow-lg flex flex-col justify-center" data-id="element-250">
            <div className="flex items-center gap-4 mb-4" data-id="element-251">
              <PhoneIcon className="w-10 h-10 shrink-0" data-id="element-252" />
              <h3 className="text-2xl font-bold" data-id="element-253">24/7 Dispatch Center</h3>
            </div>
            <a href="tel:7182103110" className="text-4xl md:text-5xl font-black tracking-tight hover:text-gray-200 transition-colors inline-block mb-2" data-id="element-254">
              718.210.3110
            </a>
            <p className="text-white/70 font-medium uppercase tracking-wider text-sm" data-id="element-255">
              Available around the clock
            </p>
          </div>
        </div>
      </div>
    </section>;
}